import App from "./app/reducers";

export default {
  App,
};
